export var generateCodeName = function (obj, codeKey, nameKey) {
    var code = obj[codeKey] ? "".concat(obj[codeKey], " - ") : '';
    var name = obj[nameKey] || '';
    return code + name;
};
